import { Component, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeProser } from '@app/models/entity.model';
import { ProductLayoutComponent } from '@app/components/product/product-layout/product-layout.component';

@Component({
  selector: 'mobi-node-proser',
  templateUrl: './node-proser.component.html',
  styleUrls: ['./node-proser.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, ProductLayoutComponent],
})
export class NodeProserComponent {
  readonly entity = input.required<NodeProser>();
}
